import Link from 'next/link';
import Image from 'next/image';
import dynamic from 'next/dynamic';
const VideoSchema = dynamic(() => import('./HomePageVideoSchema'));

interface HomepageVideoProps {
  videoOptions: any;
  videoAltText: string;
}

function HomepageVideo({ videoOptions, videoAltText }: HomepageVideoProps) {
  const desktopThumbnailUrl = videoOptions?.background_image
  const mobileThumbnailUrl = videoOptions?.mobile_background_image;
  return (
    <>
      <Link href={videoOptions?.href || '/shop'} className="block cursor-pointer">
        <VideoSchema
          videoAltText={videoAltText}
          desktopThumbnailUrl={desktopThumbnailUrl}
          mobileThumbnailUrl={mobileThumbnailUrl}
          videoUrl={videoOptions?.background_video}
        />
        <div className="relative w-full pt-[124.80%] md:hidden">
          {videoOptions?.mobile_background_video ? (
            <video
              playsInline
              autoPlay
              muted
              loop
              poster={mobileThumbnailUrl}
              className="absolute top-0 left-0 w-full h-full object-cover"
            >
              <source src={videoOptions.mobile_background_video} type="video/mp4" />
              <meta itemProp="description" content={videoAltText} />
            </video>
          ) : videoOptions?.mobile_background_image && (
            <Image
              src={videoOptions.mobile_background_image}
              alt={videoAltText}
              fill
              className="absolute top-0 left-0 w-full h-full object-cover"
              priority
            />
          )}
        </div>
        <div className="relative w-full pt-[40.00%] hidden md:block">
          {videoOptions?.background_video ? (
            <video
              playsInline
              autoPlay
              muted
              loop
              poster={desktopThumbnailUrl}
              className="absolute top-0 left-0 w-full h-full object-cover"
            >
              <source src={videoOptions.background_video} type="video/mp4" />
              <meta itemProp="description" content={videoAltText} />
            </video>
          ) : videoOptions?.background_image && (
            <Image
              src={videoOptions.background_image}
              alt={videoAltText}
              fill
              className="absolute top-0 left-0 w-full h-full object-cover"
              priority
            />
          )}
        </div>
      </Link>
    </>
  );
}

export default HomepageVideo;